import Vue from 'vue'
import App from './client_stage_order/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const clientStageBuilder = document.getElementById('client-stages-index');

  if (clientStageBuilder) {
    new Vue({
      el: '#client-stages-index',
      render: h => h(App)
    }).$mount();
  }
});